import { Box, BoxProps, styled } from '@mui/material';

interface StyleBoxProps extends BoxProps {
    success?: boolean;
    error?: boolean;
    warning?: boolean;
    purple?: boolean;
    brandblue?: boolean;
    orange?: boolean;
    info?: boolean;
}

export const CustomBadge = styled(Box, {
    shouldForwardProp: (prop) =>
        prop !== 'success' &&
        prop !== 'warning' &&
        prop !== 'error' &&
        prop !== 'purple' &&
        prop !== 'brandblue' &&
        prop !== 'orange' &&
        prop !== 'info',
})<StyleBoxProps>(({ success, warning, error, purple, brandblue, orange, info, theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    borderRadius: '6px',
    marginLeft: '12px',
    fontWeight: '500',
    lineHeight: 1,

    ...(success && {
        color: theme.palette.success.main,
        backgroundColor: theme.palette.success.light,
    }),

    ...(warning && {
        color: theme.palette.warning.main,
        backgroundColor: theme.palette.warning.light,
    }),

    ...(brandblue && {
        color: theme.palette.brandblue.main,
        backgroundColor: theme.palette.brandblue.light,
    }),

    ...(error && {
        color: theme.palette.error.main,
        backgroundColor: theme.palette.error.light,
    }),

    ...(purple && {
        color: theme.palette.purple.main,
        backgroundColor: theme.palette.purple.light,
    }),

    ...(orange && {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.warning.main,
    }),

    ...(info && {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.alpha.info[15],
    }),
}));
